import { render, staticRenderFns } from "./IconSvg.vue?vue&type=template&id=64265af6&scoped=true"
import script from "./IconSvg.vue?vue&type=script&lang=js"
export * from "./IconSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64265af6",
  null
  
)

export default component.exports